var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-grey pb-5"},[(!_vm.success)?_c('div',{staticClass:"bg-grey w-100 d-flex align-items-center justify-content-center",staticStyle:{"height":"80vh"}},[_c('div',{staticClass:"spinner-border"})]):_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }